// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PlaygroundChatAvatar-module__spinnerContainer--xq59W"};